import { appEntry } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-[1000px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-3">{appEntry.title}</h2>
        <p className="text-sm text-foreground-600 text-center max-w-2xl mx-auto mb-10">{appEntry.description}</p>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {appEntry.steps.map((step, idx) => (
            <div key={idx} className="flex flex-col items-center text-center p-5 bg-background-50 rounded-lg border border-background-200/60">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-3">
                <i className={`${step.icon} text-xl`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-700 whitespace-nowrap">{step.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}